"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const TooltipStyled_1 = __importDefault(require("./TooltipStyled"));
const Tooltip = ({ content, image }) => {
    if (!content)
        return null;
    return (react_1.default.createElement(TooltipStyled_1.default, { className: "ecr-tooltip" },
        react_1.default.createElement("div", { className: "ecr-tooltip-wrapper" },
            react_1.default.createElement("div", { className: "ecr-tooltip-popup" },
                image ? react_1.default.createElement("img", { src: image, alt: "tip" }) : null,
                react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, className: "ecr-tooltip-tip", string: content })),
            react_1.default.createElement("div", { className: "ecr-tooltip-icon" }, "?"))));
};
Tooltip.propTypes = {
    content: prop_types_1.default.string,
    image: prop_types_1.default.string
};
exports.default = Tooltip;
//# sourceMappingURL=Tooltip.js.map